/**
 * External dependencies
 */

export default class WidgetType {
  constructor(cscom) {
    if (!(this instanceof WidgetType)) {
      return new WidgetType(cscom);
    }
    this.cscom = cscom;
  }

  list(data) {
    return this.cscom.req.get(
      "/api/rest/talink/dashboard/widget-types",
      null,
      data
    );
  }

  listAll() {
    return this.cscom.req
      .get("/api/rest/talink/dashboard/widget-types", null)
      .then((result) => {
        return result._embedded.items;
      });
  }
}
